const palette = {
  // Primary - Deep ocean blue
  primary: '#1a5fb4',
  primaryH: '#144a8c',

  // Secondary - Warm gray
  secondary: '#9a9da6',
  secondaryH: '#747982',

  // Text colors
  defaultText: '#1e2a3d',

  // Links - Burnt sienna
  link: '#d04e0a',

  // Borders
  border: '#d5d3ce',

  // Status colors
  success: '#059669',
  error: '#dc2626',
  errorBg: '#fef2f2',

  // Card styling
  cardTitle: '#6b6e75',
  cardTitleBorder: '#e5e3de',

  // Form elements
  fieldHint: '#9a9da4',

  // Sidebar - Deep navy theme
  sidebarBg: '#172a40',
  sidebarBgSubtle: '#172a40',
  sidebarBgHover: '#1e3550',
  sidebarBgActive: '#3b82f6',
  sidebarText: '#94a3b8',
  sidebarTextHover: '#e2e8f0',
  sidebarTextActive: '#ffffff',
  sidebarBorder: '#1e3550',
  sidebarAccent: '#60a5fa',
  sidebarGlow: 'rgba(96, 165, 250, 0.2)',

  // App header - Clean white
  appHeaderBg: '#ffffff',
  appHeaderBorder: '#e5e3de',

  // Notifications
  notificationSuccessBg: '#059669',
  notificationWarningBg: '#f59e0b',
  notificationErrorBg: '#dc2626',
  notificationInfoBg: '#172a40',

  // Toast notifications
  toastWarningBg: '#f15a29',

  // Dialogs
  dialogErrorHeaderBg: '#dc2626',
  dialogBorder: '#e5e3de',

  // Breadcrumbs
  breadcrumbLastItem: '#6b6e75',

  // Avatar defaults
  avatarDefaultBg: '#e8e6e1',
  avatarDefaultBorder: '#d5d3ce',
  avatarDefaultColor: '#6b6e75',

  // Miscellaneous UI
  addAccountText: '#6b6e75',
  filterIcon: '#4d4f56',
  slateViewActionBg: '#e8e6e1',
  companyLogoBg: '#d5d3ce',

  // Warning states
  infoWarningBg: '#fef3c7',
  infoWarningColor: '#92400e',

  // Toggle switches
  switchTrue: '#22c55e',
  switchFalse: '#ef4444',

  // Brand colors - Refined
  brandOrange: '#f15a29',
  brandOrangeD: '#d04e0a',
  brandBlue: '#1a5fb4',
  brandBlueD: '#144a8c',

  // Base colors
  white: '#ffffff',

  // Gray scale - Warm neutrals
  grey200: '#f5f4f2',
  grey300: '#d5d3ce',
  grey400: '#9a9da4',
  grey600: '#4d4f56',
  grey800: '#1e2a3d',

  // Panel backgrounds
  slatePaneBg: '#faf9f7',

  // Image preview
  imagePreviewBg: '#f5f4f2',
  imagePreviewBorder: '#d5d3ce',
  imagePreviewLabel: '#9a9da4',

  // Table-specific colors (legacy dark theme)
  tableHeaderBg: '#172a40',
  tableHeaderCellBg: '#1e3550',
  tableRowHover: '#f5f3ef',
  tableRowSelected: '#dbeafe',
  tableRowSelectedBorder: '#93c5fd',
  tableRowSelectedFixed: '#1a5fb4',

  // Light table theme
  tableHeaderBgLight: '#f8f7f5',
  tableHeaderText: '#636770',
  tableRowWarm: '#faf9f7',
  tableRowWarmAlt: '#ffffff',
  tableBorderSubtle: '#eae8e4',
  tableSelectionBg: '#fef7ed',
  tableSelectionBorder: '#fed7aa',
};

export default palette;

// brandOrange: links, accents
// brandBlue: buttons, primary actions

// grey200: light backgrounds
// grey300: borders, subtle elements
// grey400: secondary text, placeholders
// grey600: darker accents
// grey800: primary dark elements
